import { JSEncrypt } from 'jsencrypt'

const publicKey =
  '-----BEGIN PUBLIC KEY-----' +
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1rrw8sb3NkDbIR5BrWQI' +
  'EQYA5sgEtjierWZMTPNtSybWdNO2/ARj+0Cxea1xy8eb0wvMo8UmCcT2nT18oPcv' +
  'NeoXlqfYkWWp/Daf/okFP1H440tb6Y6sTAzd9fk5BKFTsQDVs8zq4eWCH6gJOSaf' +
  'esuJHAN/8bMLMO29fLI9hpSC6LfHqjx15h/AflLrqwnhGXlQAYf5b/65L95Hgpuj' +
  'WNuH60AoRoUrTORixnnWjtnyKbwGqaQ12cAR63fh3WBS5aJ9aV+pMN3cxaFcfpBd' +
  '1BPfcN2SdudYNWmT58BRWssAqm9e/c8CBDSFPfsCDrDbGcsMdpQA9aCit1Az7dGb' +
  'nQIDAQAB' +
  '-----END PUBLIC KEY-----'

export function encrypt(data) {
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  return encrypt.encrypt(data)
}



// WEBPACK FOOTER //
// ./src/utils/rsa.js